<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="other-source"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:other-source">
                        <gofix-card title="" class="pt-4" classContent="mb-0">
                            <b-row>
                                <b-col md="3">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Month"
                                                vLabel="label"
                                                v-model="pa_data_entries_header.month"
                                                :reduce="option => option.value"
                                                required
                                                clearable
                                                :options="optionMonth">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Year"
                                                v-model="pa_data_entries_header.year"
                                                required
                                                clearable
                                                :options="optionYear">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="5">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                v-bind:class="{'run-loading small-loading': loading}"
                                                label="Select Supplier Contract"
                                                vLabel="contract_title"
                                                :reduce="option => option['id']"
                                                @search="searchSupplierContract"
                                                :filterable="false"
                                                v-model="pa_data_entries_header.contract_id"
                                                :options="optionSupplierContract">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Select Property Type"
                                                v-model="pa_data_entries_header.property_type"
                                                required
                                                clearable
                                                :options="optionPropertyType">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="12" class="text-right pt-15">
                                            <gofix-button @click="resetData" class="ml-2 mr-2" label="Reset"></gofix-button>
                                            <gofix-button :loading="save_loading" @click="saveData" class="ml-2 mr-2" label="Save"></gofix-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card fullContent classContent="mb-0 pt-15">
                            <gofix-table :settings="tableConfig"
                                :table-items="tableItems"
                                @row-click="rowClick"
                                @load-items="getTableData"
                                ref="gofixTable">
                                <template slot="gofix_table:total_weight" slot-scope="row">
                                    <span class="color-red">{{ row.item.total_weight }}%</span>
                                </template>
                                <template slot="gofix_table:max_weight" slot-scope="row">
                                    <span class="color-red">{{ row.item.max_weight }}%</span>
                                </template>
                                <template slot="gofix_table:attachment" slot-scope="row">
                                    <b-button class="btn-download-custom" v-if="row.item.attachments && checkShowBtnView(row.item.attachments)" type="button" @click="openModalDownload(row.item)">View Attachment</b-button>
                                </template>
                            </gofix-table>
                            <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                                <b-form class="formV2">
                                    <gofix-form-input-number
                                        label="Data from IEMS (%)"
                                        v-model="modal.data.data_from_iems"
                                        :integer-limit="3"
                                        suffix="%">
                                    </gofix-form-input-number>
                                    <gofix-form-input-number
                                        label="Feedback from RC (%)"
                                        v-model="modal.data.feedback_from_rc"
                                        :integer-limit="3"
                                        suffix="%">
                                    </gofix-form-input-number>
                                    <gofix-form-input-number
                                        label="Feedback from Social Media (%)"
                                        v-model="modal.data.feedback_from_sm"
                                        :integer-limit="3"
                                        suffix="%">
                                    </gofix-form-input-number>
                                    <b-row class="mb-3">
                                        <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                            <div class="title pl-15">Attachments</div>
                                            <b-button @click="deleteAttachment" v-if="modal.attachmentDeleteId.length">
                                                <div class="tooltip">Delete</div>
                                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                                </svg>
                                            </b-button>
                                            <b-button type="button" @click="modal.attachment.open = true">
                                                <div class="tooltip">Create</div>
                                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                                </svg>
                                            </b-button>
                                            <!-- <b-button type="button" @click="dowloadAttachments" v-if="modal.attachmentDeleteId.length">
                                                <div class="tooltip">Download</div>
                                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#999999"/>
                                                </svg>
                                            </b-button> -->
                                        </div>
                                    </b-row>
                                    <b-row>
                                        <b-col class="col-6 mb-3" v-for="(attachment,index) in modal.attachments" :key="index">
                                            <div class="attachmentInfo">
                                                <div class="checkbox">
                                                    <b-form-checkbox class="uniform" :value="index" v-model="modal.attachmentDeleteId"></b-form-checkbox>
                                                </div>
                                                <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                                <div class="name">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                            </div>
                                        </b-col>
                                        <b-col class="col-6 mb-3" v-for="(attachment,index) in modal.attachment_tmp.add" :key="'tmp'+index">
                                            <div class="attachmentInfo">
                                                <div class="checkbox">
                                                    <b-form-checkbox class="uniform" :value="'tmp'+index" v-model="modal.attachmentDeleteId"></b-form-checkbox>
                                                </div>
                                                <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                                <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-form>
                                <b-button-group class="d-block text-right pr-4">
                                    <gofix-button label="SUBMIT" @click="calcRow" :loading="modal.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                            <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modal.attachment.open">
                                <b-form class="formV2">
                                    <gofix-form-input label="File Title" v-model="modal.attachment.image_file_title"></gofix-form-input>
                                    <b-form-group :label="modal.attachment.filename">
                                        <b-form-file ref="file-input" v-model="modal.attachment.fileAttachment" ></b-form-file>
                                    </b-form-group>
                                    <b-button-group class="text-right d-block">
                                        <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modal.attachment.loading"></gofix-button>
                                    </b-button-group>
                                </b-form>
                            </b-modal>
                            <!--File form edit-->
                            <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments-edit" id="modal-Contract-Attachments" hide-footer>
                                <b-form class="formV2">
                                    <gofix-form-input label="File Title" v-model="modal.attachment.image_file_title"></gofix-form-input>
                                    <b-form-group :label="modal.attachment.filename">
                                        <b-form-file ref="file-input" v-model="modal.attachment.fileAttachment" ></b-form-file>
                                    </b-form-group>
                                    <b-button-group class="text-right d-block">
                                        <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modal.attachment.loading"></gofix-button>
                                    </b-button-group>
                                </b-form>
                            </b-modal>
                            <b-modal :no-close-on-backdrop="true" :title="modal.download.title"  v-model="modal.download.open" modal-class="w-360" id="modal-Contract-Attachments" hide-footer>
                                <b-form class="formV2">
                                    <div class="items items-attachment-custom">
                                        <template v-for="(attachment, index) in modal.download.attachments">
                                            <div class="item" :key="index">
                                                <div class="item-content position-relative">
                                                    <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                                    <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <b-button-group class="text-left d-block">
                                        <gofix-button class="btn-download-custom" @click="proccessDownloadAttachment" label="Download All" :loading="modal.download.loading"></gofix-button>
                                    </b-button-group>
                                </b-form>
                            </b-modal>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';

    export default {
        name: 'pa-data-entries-other-sources',
        components: {

        },
        props: {
            nameTable: {
                type: String,
                default: 'pa-data-entries-other-sources'
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['pa_other_sources']));
            return {
                tabs: tabData.performance_assesment_data_entries,
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: false,
                        delete: false,
                        tableColumnSettings:false,
                        tableImport:false,
                        tableExport:false,
                        tableFilter:false,
                        reload:false,
                        tablePagination:false
                    },
                    fields:[
                        {
                            key: 'property_name',
                            label: 'Location',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'data_from_iems',
                            label: 'Data from IEMS (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'feedback_from_rc',
                            label: 'Feedback from RC (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'feedback_from_sm',
                            label: 'Feedback from Social Media (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:250px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'total_weight',
                            label: 'Total Weightage (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'max_weight',
                            label: 'Max Weightage (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'attachment',
                            label: 'Attachment',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                    ],
                    filter:filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortDirection: "desc"
                },
                tableItems:[],
                pa_data_entries_header:{
                    month:null,
                    year:null,
                    contract_id:null,
                    property_type: 'Residential'
                },
                pa_request:null,
                optionMonth:[],
                optionYear:[],
                optionSupplierContract:[],
                optionPropertyType:[
                    'Residential',
                    'Hawker Centre'
                ],
                isAction:false,
                timer:null,
                modal:{
                    open:false,
                    title:null,
                    loading:false,
                    data:{
                        data_from_iems:null,
                        feedback_from_rc:null,
                        feedback_from_sm:null
                    },
                    index:null,
                    attachments: [],
                    attachmentUpdate: [],
                    attachmentDeleteId: [],
                    attachment_tmp: {
                        delete: [],
                        add:[],
                        update: []
                    },
                    attachment:{
                        open:false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment:null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                    download:{
                        open:false,
                        loading:false,
                        title:'',
                        attachments:[]
                    }
                },
                header_id:null,
                loading:false,
                save_loading:false,
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                }
            }
        },
        filters: {
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        created() {
            this.getYear();
            this.getMonth();

            this.pa_data_entries_header.month = parseInt(moment().format('M'))
            this.pa_data_entries_header.year = parseInt(moment().format('YYYY'))
            this.getSupplierContract();
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {
            ClientContractID: function(val) {
                this.getSupplierContract();
            },
            "modal.attachment.fileAttachment": function(val, old) {
                this.modal.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .zip, .html, .msg, .csv, .pdf, .txt, .jpeg, .jpg, .png, .gif file!", "warning");
                    }
                    this.modal.attachment.filename = val.name
                }
            },
            "modal.attachment.open": function(val) {
                // this.getDataEntriesHeader();
            },
            "pa_data_entries_header.month": function(val){
                if(val){
                    this.getDataEntriesHeader();
                }
            },
            "pa_data_entries_header.year": function(val){
                if(val){
                    this.getDataEntriesHeader();
                }
            },
            "pa_data_entries_header.contract_id": function(val){
                if(val){
                    this.getDataEntriesHeader();
                }
            },
            "pa_data_entries_header.property_type": function(val){
                if(val){
                    this.getDataEntriesHeader();
                }
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();

                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type
                ){
                    const response = {
                        items: [],
                        total: 0
                    }
                    resolve(response);
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    return;
                }

                let filter = Object.assign({}, this.pa_data_entries_header);
                filter.type = 'other source';
                await this.$store.dispatch("PAConservancyController/getItems", filter)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    // this.$alertNotification("Can not load other resource .", "danger");
                    reject();
                });
            },
            rowClick(val,index){
                this.modal.title = val.property_name;
                this.modal.data.data_from_iems = val.data_from_iems;
                this.modal.data.feedback_from_rc = val.feedback_from_rc;
                this.modal.data.feedback_from_sm = val.feedback_from_sm;
                this.modal.index = index;
                // this.resetFormImport();
                this.modal.attachment_tmp.add = [];
                this.modal.attachment_tmp.update = [];
                this.modal.attachment_tmp.delete = [];
                //.
                this.modal.attachments  = [];
                if(val.attachments && val.attachments.length > 0){
                    this.modal.attachments  = JSON.parse(JSON.stringify(val.attachments));
                }
                this.modal.open = true;
            },
            getYear(){
                let min_year = 2008;
                let current_year = new Date().getFullYear();
                for(let i = current_year; i >= min_year; i--){
                    this.optionYear.push(i);
                }
            },
            getMonth(){
                let monthsRequired = 12;
                let m = moment("2010-January-01","YYYY-MMMM-DD");
                for (let i = 0; i < monthsRequired; i++) {
                    let mClone = m.clone();
                    this.optionMonth.push({
                        label: mClone.add(i, 'months').format('MMMM'),
                        value:(i+1)
                    })
                }
            },  
            previewData(){
                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type
                ){
                    return this.$alertNotification("The field is required", "danger");
                }
                // check header
                this.getDataEntriesHeader();
            },
            async getDataEntriesHeader(val){
                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type
                ){
                    // return this.$alertNotification("The field is required", "danger");
                    return false
                }
                this.loading = true;
                this.header_id = null;
                let tableRequest = {
                    filter: this.pa_data_entries_header,
                    limit: 1,
                    page: 1,
                    isCMS: 0,
                    sortColumn:'id',
                    useDatabaseView: false
                }
                let header = null;
                await this.$store.dispatch("PAConservancyController/getEntryHeader", tableRequest)
                .then(response => {
                    if(response.items){
                        this.header_id = response.items[0].id;
                    }
                })
                .catch(err => {})
                //
                if(this.header_id){
                    let param = {
                        id:this.header_id,
                        hide_property_deleted: val && val || 0
                    }
                    await this.$store.dispatch("PAConservancyController/getCustomEntryHeaderID", param)
                    .then(response => {
                        this.tableItems = response.other_source_items;
                        this.tableItems.total = response.other_source_items.length;
                    })
                    .catch(err => {})
                }else{
                    this.$refs.gofixTable.reloadTableItems();
                }
                this.loading = false;
            },
            async searchSupplierContract(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getSupplierContract(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async getSupplierContract(search = null) {
                this.loading = true
                let tableRequest = {
                    filter: {
                        contract_title: { type: "text", value: search, function: "ilike", with: [] },
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                    },
                    limit: 100,
                    page: 1,
                    isCMS: 1,
                    useDatabaseView: true,
                    sortColumn: "contract_title",
                    sortDirection: "ASC"
                }
                await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
                .then(response => {

                    this.tableItems = [];
                    this.tableConfig.total = 0;

                    this.optionSupplierContract = response.data.data.contracts

                    if(search === null) {
                        this.pa_data_entries_header.contract_id = null
                        if(response.data.data.contracts[0].id){
                            this.pa_data_entries_header.contract_id = response.data.data.contracts[0].id
                        }
                    }
                    
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            },
            calcRow(){
                let data_from_iems = this.$accounting.unformat(this.modal.data.data_from_iems);
                let feedback_from_rc = this.$accounting.unformat(this.modal.data.feedback_from_rc);
                let feedback_from_sm = this.$accounting.unformat(this.modal.data.feedback_from_sm);
                let index = this.modal.index;
                let total = data_from_iems + feedback_from_rc + feedback_from_sm;
                if(total > 100){
                    return this.$alertNotification("The sum cannot be more than 100 percent", "danger");
                }
                this.tableItems[index].data_from_iems = data_from_iems;
                this.tableItems[index].feedback_from_rc = feedback_from_rc;
                this.tableItems[index].feedback_from_sm = feedback_from_sm;
                this.tableItems[index].total_weight = total;

                // add attachment
                let adds = [];
                if(this.tableItems[index].attachmentAdd && this.tableItems[index].attachmentAdd.length) adds = this.tableItems[index].attachmentAdd
                this.tableItems[index].attachmentAdd = adds.concat(this.modal.attachment_tmp.add)

                let del_adds = this.modal.attachment_tmp.delete.filter(item => item.id_tmp)
                if(del_adds) this.tableItems[index].attachmentAdd.filter(item => item.id_tmp && del_adds.includes(item.id_tmp))

                this.tableItems[index].attachmentUpdate = Object.assign([], this.modal.attachment_tmp.update);

                // delete attachment
                let dels = [];
                if(this.tableItems[index].attachmentDelete && this.tableItems[index].attachmentDelete.length) dels = this.tableItems[index].attachmentDelete
                this.tableItems[index].attachmentDelete = dels.concat(this.modal.attachment_tmp.delete)

                this.tableItems[index].attachments = JSON.parse(JSON.stringify(this.modal.attachments));
                if(this.modal.attachment_tmp.add.length) {
                    this.modal.attachment_tmp.add.forEach(item => {
                        let obj = item;
                        obj.image_content_type = item.type
                        obj.image_file_name = item.name
                        this.tableItems[index].attachments.push(item);
                    })
                }
                
                this.modal.open = false;
                // save data
                let request = Object.assign([], this.tableItems);
                this.pa_request = {
                    year: this.pa_data_entries_header.year,
                    month: this.pa_data_entries_header.month,
                    type: 'other source',
                    contract_id: this.pa_data_entries_header.contract_id,
                    property_type: this.pa_data_entries_header.property_type,
                    items: request
                };
            },
            saveData(){
                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type
                ){
                    return this.$alertNotification("The field is required", "danger");
                }
                if(this.tableItems.length == 0){
                    return this.$alertNotification("Data empty so they cannot be created", "danger");
                }
                this.save_loading = true;
                if(!this.pa_request){
                    this.pa_request = {
                        year: this.pa_data_entries_header.year,
                        month: this.pa_data_entries_header.month,
                        type: 'other source',
                        contract_id: this.pa_data_entries_header.contract_id,
                        property_type: this.pa_data_entries_header.property_type,
                        items: Object.assign([], this.tableItems)
                    };
                }
                this.$store.dispatch(`PAConservancyController/createDataEntriesOtherSource`, this.pa_request)
                    .then(response => {
                        this.pa_request = null;
                        this.save_loading = false;
                        this.tableItems = response.other_source_items;
                        return this.$alertNotification("Saved successfully", "success");
                    })
                    .catch(err => {
                        this.save_loading = false;
                        //console.log(err);
                        // this.modals.remark.loading = false;
                    })
            },
            addAttachment(){
                if( this.modal.attachment.filename == 'Click Browse to upload file' && !this.modal.attachment.fileAttachment ) {
                    return this.$alertNotification("Please select a file", "danger");
                }

                if(this.modal.attachment.index !== '') {
                    if(this.modal.attachment.id != 0) {
                        if(this.modal.attachments[this.modal.attachment.index]) {
                            this.modal.attachments[this.modal.attachment.index].image_file_title = this.modal.attachment.image_file_title
                            this.modal.attachments[this.modal.attachment.index].image_file_name = this.modal.attachment.fileAttachment ? this.modal.attachment.fileAttachment.name : this.modal.attachments[this.modal.attachment.index].image_file_name
                            let index = this.modal.attachment_tmp.update.findIndex(item => item.id == this.modal.attachment.id)
                            if(index != -1) {
                                this.modal.attachment_tmp.update[index] = Object.assign(this.modal.attachment_tmp.update[index], {
                                    image_file_title: this.modal.attachment.image_file_title,
                                    attachment: this.modal.attachment.fileAttachment || this.modal.attachment_tmp.update[index].attachment
                                })
                            } else {
                                this.modal.attachment_tmp.update.push({
                                    id: this.modal.attachment.id,
                                    image_file_title: this.modal.attachment.image_file_title,
                                    attachment: this.modal.attachment.fileAttachment
                                })
                            }
                        }
                    } else {
                        let idx = this.modal.attachment.index.slice(3);
                        if(this.modal.attachment_tmp.add[idx]) {
                            this.modal.attachment_tmp.add[idx] = this.modal.attachment_tmp.add[idx] || this.modal.attachment.fileAttachment;
                            this.modal.attachment_tmp.add[idx].image_file_title = this.modal.attachment.image_file_title
                            this.modal.attachment_tmp.add[idx].id_tmp = `tmp_${this.generalKeyId()}`
                        }
                    }
                    this.$refs['modal-Import-attachments-edit'].hide();
                } else {
                    // add attachment
                    this.modal.attachment.fileAttachment.image_file_title = this.modal.attachment.image_file_title;
                    this.modal.attachment.fileAttachment.id_tmp = `tmp_${this.generalKeyId()}`
                    this.modal.attachment_tmp.add.push(this.modal.attachment.fileAttachment);
                }
                this.resetFormImport();
                this.modal.attachment.open = false;
            },
            deleteAttachment(){
                if(this.modal.attachmentDeleteId.length > 0){
                    this.modal.attachmentDeleteId = this.modal.attachmentDeleteId.sort().reverse();
                    for(let index of this.modal.attachmentDeleteId){
                        if( typeof(index) == "string" && index.includes("tmp")) {
                            index = index.slice(3);
                            let item = this.modal.attachment_tmp.add.splice(index, 1);
                            if(item && item[0]) this.modal.attachment_tmp.delete.push({
                                id_tmp: item[0].id_tmp
                            })
                        }else {
                            let item = this.modal.attachments.splice(index, 1);
                            this.modal.attachment_tmp.delete.push(item[0])
                        }
                    }
                }
                this.modal.attachmentDeleteId.length = 0;
            },
            // dowloadAttachments(){

            // },
            resetFormImport() {
                this.modal.attachment.filename = 'Click Browse to upload file';
                this.modal.attachment.fileAttachment = null;
                this.modal.attachment.image_file_title = null;
                this.modal.attachment.id = 0;
                this.modal.attachment.index = '';
            },
            checkShowIcon(val){
                if(!val) return false;
                let type = val.type || val.image_content_type;
                if(!type) return false;
                let arrTemp = type.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },
            openModalDownload(val){
                this.modal.download.title = val.property_name;
                this.modal.download.attachments = val.attachments.filter(item => item.id);
                this.modal.download.open = true;
            },
            async proccessDownloadAttachment(){
                if(this.modal.download.attachments.length > 0){
                    this.modal.download.loading = true;
                    for(let i = 0; i < this.modal.download.attachments.length; i++){
                        let item = this.modal.download.attachments[i];
                        let url = item.url.original;
                        let params = {};
                        params.url = url;
                        params.image_file_name = item.image_file_name;

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                        .then(response => {
                        })
                        .catch(err => {
                            this.$alertNotification("Can not download file", "danger");
                            //console.log(err);
                        });
                    }
                    this.modal.download.loading = false;
                    this.modal.download.open = false;
                    return this.$alertNotification("Download attachment successfully!");
                }
            },
            generalKeyId() {
                return String(
                    Date.now().toString(32) +
                    Math.random().toString(16)
                ).replace(/\./g, '')
            },
            checkShowBtnView(attachments) {
                if(!attachments.length) return false
                let filters = attachments.filter(item => !item.id);
                if(filters.length == attachments.length) return false
                return true
            },
            resetData(){
                this.getDataEntriesHeader(1);
            }
        }
    }
</script>